import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useMemo, useState } from 'react';
import { SWIPE_DIRECTION } from "../hooks/useSwipe";

var findCurrentAlertIndex = function findCurrentAlertIndex(id, alerts) {
  return alerts.findIndex(function (alert) {
    return alert.id === id;
  });
};

export function useTechnicalMessage(params) {
  var _params$alerts = params.alerts,
      alerts = _params$alerts === void 0 ? [] : _params$alerts,
      onClose = params.onClose,
      onShow = params.onShow;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      closedAlerts = _useState2[0],
      setClosedAlerts = _useState2[1];

  var _useState3 = useState(alerts[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      currentAlert = _useState4[0],
      setCurrentAlert = _useState4[1];

  var filteredAlerts = useMemo(function () {
    return alerts.reduce(function (prev, curr) {
      var isFound = closedAlerts.some(function (alert) {
        return alert.id === curr.id;
      });
      return isFound ? prev : [].concat(_toConsumableArray(prev), [curr]);
    }, []);
  }, [alerts, closedAlerts]);

  var handleShow = function handleShow(id) {
    var currentIndex = findCurrentAlertIndex(id, filteredAlerts);
    if (onShow) onShow(filteredAlerts[currentIndex]);
  };

  var handleClose = function handleClose(id) {
    var currentIndex = findCurrentAlertIndex(id, filteredAlerts);
    var closedAlert = filteredAlerts[currentIndex];
    var filteredMessages = filteredAlerts.filter(function (item) {
      return item.id !== id;
    });
    if (onClose) onClose(filteredAlerts[currentIndex]);
    setClosedAlerts(function (prev) {
      return [].concat(_toConsumableArray(prev), [closedAlert]);
    });

    if (currentIndex === 0 && filteredAlerts.length) {
      setCurrentAlert(filteredMessages[0]);
    }

    if (currentIndex !== 0 && filteredAlerts.length) {
      setCurrentAlert(filteredMessages[currentIndex - 1]);
    }
  };

  var handleNext = function handleNext(id) {
    var currentIndex = findCurrentAlertIndex(id, filteredAlerts);

    if (currentIndex < filteredAlerts.length - 1) {
      setCurrentAlert(filteredAlerts[currentIndex + 1]);
    } else {
      setCurrentAlert(filteredAlerts[0]);
    }
  };

  var handlePrev = function handlePrev(id) {
    var currentIndex = findCurrentAlertIndex(id, filteredAlerts);

    if (currentIndex !== 0) {
      setCurrentAlert(filteredAlerts[currentIndex - 1]);
    } else {
      setCurrentAlert(filteredAlerts[filteredAlerts.length - 1]);
    }
  };

  var handleSwipe = function handleSwipe(direction) {
    switch (direction) {
      case SWIPE_DIRECTION.LEFT:
        handleNext(currentAlert.id);
        break;

      case SWIPE_DIRECTION.RIGHT:
        handlePrev(currentAlert.id);
        break;

      default:
        break;
    }
  };

  return {
    visibleAlerts: filteredAlerts,
    currentAlert: currentAlert,
    handleClose: handleClose,
    handleNext: handleNext,
    handlePrev: handlePrev,
    handleSwipe: handleSwipe,
    handleShow: handleShow
  };
}